import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { switchMap, tap } from 'rxjs';
import { resetPasswordApi } from 'src/app/shared/constants/api.constants';
import { Toast } from 'src/app/shared/enums/toast';
import { ToastService, HttpBaseService } from '@evento-ng/libs';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
})
export class ResetComponent implements OnInit {
  mobileField = new UntypedFormControl(null, [Validators.required]);
  constructor(
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private dataService: HttpBaseService,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {}

  reset(): void {
    this.spinner.show();
    this.recaptchaV3Service
      .execute('otpResendApi')
      .pipe(
        switchMap((token) => {
          return this.dataService.post(`${resetPasswordApi}`, {
            mobile: this.mobileField.value.number,
            mobileRegionCode: this.mobileField.value.countryCode,
            recaptcha: token,
          });
        }),
        tap((_) => {
          this.spinner.hide();
          this.router.navigate(['/auth/otp'], {
            queryParams: {
              mobile: this.mobileField.value.number,
              mobileRegionCode: this.mobileField.value.countryCode,
              action: 'reset',
            },
          });
          this.toast.show(
            'Success',
            this.translate.instant('Activation code has been sent'),
            {
              classname: Toast.success,
            }
          );
        })
      )
      .subscribe();
  }
}
